import React from 'react';
import { compose } from 'ramda';
import moment from 'moment';
import styleFile from './header.js';
import { Icon, RichText } from '@synergycms_core/components/generic';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { isUsDomain } from 'synergycms_core/src/utils/utils.js';


function formatDateStrings(dateStart, dateEnd, dateFormat = 'minified', modalBreak) {
  const startMoment = moment.isMoment(dateStart) ? dateStart : moment(dateStart);
  const endMoment = moment.isMoment(dateEnd) ? dateEnd : moment(dateEnd);

  const formatMinified = (start, end) => {
    const sameMonth = start.format('MMM') === end.format('MMM');
    if (sameMonth) {
      return {
        dateStartFormated: start.format(isUsDomain() ? 'MMM D' : 'D'),
        dateEndFormated: end.format(isUsDomain() ? 'D' : 'D MMM')
      };
    }
    return {
      dateStartFormated: start.format(isUsDomain() ? 'MMM D' : 'D MMM'),
      dateEndFormated: end.format(isUsDomain() ? 'MMM D' : 'D MMM')
    };
  };

  const formatStacked = (start, end) => {
    const format = (date) =>
      date.format('D[<br/>]ddd, ') + date.format('MMM').toUpperCase();

    return {
      dateStartFormated: format(start),
      dateEndFormated: format(end)
    };
  };

  switch (dateFormat) {
    case 'minified':
      return formatMinified(startMoment, endMoment);
    case "stacked":
        return modalBreak ? formatMinified(startMoment, endMoment) : formatStacked(startMoment, endMoment);
    case 'default':
      return {
        dateStartFormated: startMoment.format(isUsDomain() ? 'MM/DD/YYYY' : 'DD/MM/YYYY'),
        dateEndFormated: endMoment.format(isUsDomain() ? 'MM/DD/YYYY' : 'DD/MM/YYYY')
      };
    default:
      return formatMinified(startMoment, endMoment);
  }
}

const DateInfo = compose(withThemeJSS({ styleFile, displayName: 'Header' }))((props) => {
  const { theme, dateStart, dateEnd, dateFormat, modalBreak } = props;
  const { classes } = theme.styles;

  const isDateInvalid = !dateStart || moment(dateStart).startOf('day').isBefore(moment().startOf('day'));

  const { dateStartFormated, dateEndFormated } = formatDateStrings(dateStart, dateEnd, dateFormat, modalBreak);

  if (isDateInvalid) {
    return (
      <>
      <div className={classes.containerInvalidDate}>
        <RichText ucFirst={true} translate={true} text={'_%entrada%_'} innerStyle={classes.headerTitle} />
        <RichText text={' - '} innerStyle={classes.headerTitle} />
        <RichText ucFirst={true} translate={true} text={'_%salida%_'} innerStyle={classes.headerTitle} />
      </div>
      </>
    );
  }

  if (dateFormat === 'stacked' && !modalBreak) {
    return  (
      <div className={classes.stackedDateCont}>
        <div className={classes.startDate}>
          <RichText dangerouslySetInnerHTML={dateStartFormated.replace(/\./g, '')} innerStyle={'capitalize'} />
        </div>
        <div className={classes.dateSeparator}>
          <Icon unicodeContent={'7b'} innerStyle={classes.iconSeparator} />
        </div>
        <div className={classes.endDate}>
          <RichText dangerouslySetInnerHTML={dateEndFormated.replace(/\./g, '')} innerStyle={'capitalize'} />
        </div>
      </div>
    );
  }

  return <RichText dangerouslySetInnerHTML={[dateStartFormated, ' - ', dateEndFormated].join(' ')} innerStyle={classes.headerTitle} />;
});


export default DateInfo;